import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PwaUpdateNotificationComponent } from './pwa-update-notification/pwa-update-notification.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [RouterOutlet, PwaUpdateNotificationComponent],
})
export class AppComponent {
  title = 'oak-checkin-site';
}
